import { BDShared } from '@brother-apps/brother-dealerapp-shared-lib';
import { Injectable } from '@angular/core';

@Injectable()
export class BDCPShareService {

    public sharedModel: BDShared;

    public customerMode: boolean;

    public visitedPages: string[] = [];
}
